
import $ from 'jquery';

function mouseOverHandler(e) {
	const first = document.querySelectorAll('.first__image img')[0];
	const third = document.querySelectorAll('#s-flower-m image')[0];
	const fifth = document.querySelectorAll('.fifth__image img')[0];
	const arr = [first, third, fifth];
	const pageX = e.clientX;
	const pageY = e.clientY;
	arr.forEach((item, i) => {
		if (i === 1) {
			item.style.webkitTransform = `translateX(${-pageX / 100}%) translateY(${-pageY / 100}%) scale(1.2)`;
			item.style.transform = `translateX(${-pageX / 100}%) translateY(${-pageY / 100}%) scale(1.2)`;
		} else {
			item.style.webkitTransform = `translateX(${pageX / 100}%) translateY(${pageY / 100}%) scale(1.2)`;
			item.style.transform = `translateX(${pageX / 100}%) translateY(${pageY / 100}%) scale(1.2)`;
		}
	});
}

$(() => {
	document.addEventListener('mousemove', (e) => mouseOverHandler(e));
});



// WEBPACK FOOTER //
// ./app/scripts/app.js